export default __webpack_public_path__ + "static/folic-acid-c50e3318edbe29e5aeb8f24d9b73c925.jpg";